import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  useCallback,
  useEffect,
} from 'react';
import ReactDOM from 'react-dom';

const PopupContext = createContext();

export const PopupBuilder = ({ children }) => {
  const [popup, setPopup] = useState(null);
  const [toast, setToast] = useState(null);
  const [drawer, setDrawer] = useState(null);

  const showPopup = useCallback((component) => setPopup(component), []);
  const hidePopup = useCallback(() => setPopup(null), []);

  const showToast = useCallback((component) => setToast(component), []);
  const hideToast = useCallback(() => setToast(null), []);

  const showDrawer = useCallback((component) => setDrawer(component), []);
  const hideDrawer = useCallback(() => setDrawer(null), []);

  const contextValue = useMemo(() => ({
    showPopup,
    hidePopup,
    showToast,
    hideToast,
    showDrawer,
    hideDrawer,
  }), [showPopup, hidePopup, showToast, hideToast, showDrawer, hideDrawer]);

  return (
    <PopupContext.Provider value={contextValue}>
      {children}
      <PopupPortal id="popup-root" component={popup} />
      <PopupPortal id="toast-root" component={toast} />
      <PopupPortal id="drawer-root" component={drawer} />
    </PopupContext.Provider>
  );
};

const PopupPortal = React.memo(({ id, component }) => {

  if (typeof window === 'undefined') return null;

  const container = document.getElementById(id);
  if (!container || !component) return null;

  return ReactDOM.createPortal(component, container);
});

export const usePopup = () => useContext(PopupContext);
